import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeCountDown from "./timeCountDown";
import { toast } from "react-toastify";

const GameCard = ({ item }) => {
  const [isGameClose, setIsGameClose] = useState(true);

  const navigate = useNavigate();
  return (
    <div className="bg-white px-3 py-2 game-card my-2" style={{borderRadius: 10}}>
      <div className="flex-row d-flex justify-content-between align-items-start">
        <div className="col-8 text-start">
          <h6 className="title m-0" >{item.name}</h6>
          <label className="text-danger">{item.result}</label>
        </div>
        <div className="col-4 d-flex flex-column align-items-end">
          <div
            className="bg-success px-2 rounded"
            onClick={() => {
              !isGameClose
                ? navigate("/gamedetail", { state: item })
                : toast.error("Game not started yet");
            }}
          >
            <i class="bi bi-play-circle-fill text-white fs-3" />
          </div>
          <TimeCountDown setIsGameClose={setIsGameClose} targetTime={item.close_time} />
        </div>
      </div>
      <div className="flex-row d-flex justify-content-between">
        <label className="time">OPEN - {item.open_time}</label>
        <label className="time">CLOSE - {item.close_time}</label>
      </div>
    </div>
  );
};

export default GameCard;



/*

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeCountDown from "./timeCountDown";
import { toast } from "react-toastify";

const GameCard = ({ item }) => {
  const [isGameClose, setIsGameClose] = useState(true);
  const navigate = useNavigate();

  return (
    <div
      className="bg-white p-2 game-card my-2 shadow-sm d-flex align-items-center"
      style={{
        borderRadius: "12px",
        transition: "all 0.3s ease-in-out",
        border: "1px solid #ddd",
        width: "100%",
        minHeight: "60px",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
    
      <div className="d-flex flex-column" style={{ flex: 1 }}>
        <h6 className="m-0 fw-bold text-primary" style={{ fontSize: "13px" }}>
          {item.name}
        </h6>
        <small className="text-danger fw-semibold" style={{ fontSize: "12px" }}>
          {item.result}
        </small>
      </div>

     
      <div className="d-flex flex-column text-center">
        <small className="text-muted" style={{ fontSize: "11px",marginRight:'10px' }}>
          Open: {item.open_time}
        </small>
        <small className="text-muted" style={{ fontSize: "11px",marginRight:'10px' }}>
          Close: {item.close_time}
        </small>
      </div>

      <div className="d-flex flex-column align-items-center">
      
        <div
          className="bg-success px-2 rounded"
          style={{ cursor: isGameClose ? "not-allowed" : "pointer" }}
          onClick={() =>
            !isGameClose
              ? navigate("/gamedetail", { state: item })
              : toast.error("Game not started yet")
          }
        >
          <i className="bi bi-play-circle-fill text-white fs-3" />
        </div>

     
        <TimeCountDown
          setIsGameClose={setIsGameClose}
          targetTime={item.close_time}
          textSize="10px" // Custom smaller text for timer
        />
      </div>
    </div>
  );
};

export default GameCard;


*/